import { render } from "./slides_iframe_db_chap04.vue?vue&type=template&id=49d751c6&scoped=true"
import script from "./slides_iframe_db_chap04.vue?vue&type=script&lang=js"
export * from "./slides_iframe_db_chap04.vue?vue&type=script&lang=js"

import "./slides_iframe_db_chap04.vue?vue&type=style&index=0&id=49d751c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d751c6"]])

export default __exports__